import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";
import { configureStore } from "@reduxjs/toolkit";
import { updateWishlist } from "../firestore/wishlist";
import userSlice from "../redux/user";
import wishlistSlice from "./wishlist";
import {
  addWishlist,
  removeItem,
  removeWishlist,
  updateItem,
} from "./wishlist";

const listenerMiddleware = createListenerMiddleware();

export const store = configureStore({
  reducer: {
    wishlists: wishlistSlice,
    user: userSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(listenerMiddleware.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppStore = typeof store;

listenerMiddleware.startListening({
  matcher: isAnyOf(removeItem, updateItem, addWishlist, removeWishlist),
  effect: async (action, listenerApi) => {
    const state: RootState = listenerApi.getState() as RootState;

    console.log("Middleware", action);

    state.wishlists.wishlists.forEach((wishlist) => {
      updateWishlist(wishlist);
    });
  },
});
